Globo.FormBuilder.forms[20198] = {
  header: {
    active: true,
    title: 'Contact us',
    description: "Leave your message and we'll get back to you shortly.",
  },
  elements: [
    {
      id: 'text',
      type: 'text',
      label: 'Your Name',
      placeholder: 'Your Name',
      description: '',
      required: true,
      columnWidth: 50,
    },
    {
      id: 'email',
      type: 'email',
      label: 'Email',
      placeholder: 'Email',
      description: '',
      required: true,
      columnWidth: 50,
    },
    {
      id: 'textarea',
      type: 'textarea',
      label: 'Message',
      placeholder: 'Message',
      description: '',
      required: true,
      columnWidth: 100,
    },
  ],
  'add-elements': null,
  footer: {
    description: '',
    previousText: 'Previous',
    nextText: 'Next',
    submitText: 'Submit',
    submitFullWidth: false,
    submitAlignment: 'left',
  },
  mail: {
    admin: null,
    customer: {
      enable: true,
      emailType: 'elementEmail',
      emailId: 'email',
      note:
        'You can use variables which will help you create a dynamic content',
      subject: 'Thanks for submitting',
      content:
        '<table class="header row" style="width: 100%; border-spacing: 0; border-collapse: collapse; margin: 40px 0 20px;">\n<tbody>\n<tr>\n<td class="header__cell" style="font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;"><center>\n<table class="container" style="width: 559px; text-align: left; border-spacing: 0px; border-collapse: collapse; margin: 0px auto;">\n<tbody>\n<tr>\n<td style="font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu, Cantarell, \'Fira Sans\', \'Droid Sans\', \'Helvetica Neue\', sans-serif; width: 544.219px;">\n<table class="row" style="width: 100%; border-spacing: 0; border-collapse: collapse;">\n<tbody>\n<tr>\n<td class="shop-name__cell" style="font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;">\n<h1 class="shop-name__text" style="font-weight: normal; font-size: 30px; color: #333; margin: 0;"><a class="shop_name" target="_blank" rel="noopener">Shop</a></h1>\n</td>\n<td class="order-number__cell" style="font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif; font-size: 14px; color: #999;" align="right">&nbsp;</td>\n</tr>\n</tbody>\n</table>\n</td>\n</tr>\n</tbody>\n</table>\n</center></td>\n</tr>\n</tbody>\n</table>\n<table class="row content" style="width: 100%; border-spacing: 0; border-collapse: collapse;">\n<tbody>\n<tr>\n<td class="content__cell" style="font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif; padding-bottom: 40px;"><center>\n<table class="container" style="width: 560px; text-align: left; border-spacing: 0; border-collapse: collapse; margin: 0 auto;">\n<tbody>\n<tr>\n<td style="font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;">\n<h2 class="quote-heading" style="font-weight: normal; font-size: 24px; margin: 0 0 10px;">Thank you for your submission</h2>\n<p class="quote-heading-message">Hi, we are getting your submission. We will get back to you shortly.</p>\n</td>\n</tr>\n</tbody>\n</table>\n<table class="row section" style="width: 100%; border-spacing: 0; border-collapse: collapse; border-top-width: 1px; border-top-color: #e5e5e5; border-top-style: solid;">\n<tbody>\n<tr>\n<td class="section__cell" style="font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif; padding: 40px 0;"><center>\n<table class="container" style="width: 560px; text-align: left; border-spacing: 0; border-collapse: collapse; margin: 0 auto;">\n<tbody>\n<tr>\n<td style="font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;">\n<h3 class="more-information">More information</h3>\n<p>{{data}}</p>\n</td>\n</tr>\n</tbody>\n</table>\n</center></td>\n</tr>\n</tbody>\n</table>\n<table class="row footer" style="width: 100%; border-spacing: 0; border-collapse: collapse; border-top-width: 1px; border-top-color: #e5e5e5; border-top-style: solid;">\n<tbody>\n<tr>\n<td class="footer__cell" style="font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif; padding: 35px 0;"><center>\n<table class="container" style="width: 560px; text-align: left; border-spacing: 0; border-collapse: collapse; margin: 0 auto;">\n<tbody>\n<tr>\n<td style="font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;">\n<p class="contact" style="text-align: center;">If you have any questions, reply to this email or contact us at <a href="mailto:shopifypartner@futureshirts.com">shopifypartner@futureshirts.com</a></p>\n</td>\n</tr>\n<tr>\n<td style="font-family: -apple-system, BlinkMacSystemFont, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;">\n<p class="disclaimer__subtext" style="color: #999; line-height: 150%; font-size: 14px; margin: 0; text-align: center;">Click <a href="[UNSUBSCRIBEURL]">here</a> to unsubscribe</p>\n</td>\n</tr>\n</tbody>\n</table>\n</center></td>\n</tr>\n</tbody>\n</table>\n</center></td>\n</tr>\n</tbody>\n</table>',
      islimitWidth: false,
      maxWidth: '600',
    },
  },
  appearance: {
    layout: 'default',
    width: 600,
    style: 'classic',
    mainColor: '#EB1256',
    headingColor: '#000',
    labelColor: '#000',
    descriptionColor: '#6c757d',
    optionColor: '#000',
    background: 'none',
    backgroundColor: '#FFF',
    backgroundImage: '',
    backgroundImageAlignment: 'middle',
    floatingIcon:
      '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="envelope" class="svg-inline--fa fa-envelope fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"></path></svg>',
    floatingText: '',
    displayOnAllPage: false,
    position: 'bottom right',
  },
  reCaptcha: {
    enable: false,
    note:
      'Please make sure that you have set Google reCaptcha v2 Site key and Secret key in <a href="/admin/settings">Settings</a>',
  },
  errorMessage: {
    required: 'Please fill in field',
    invalid: 'Invalid',
    invalidName: 'Invalid name',
    invalidEmail: 'Invalid email',
    invalidURL: 'Invalid URL',
    invalidPhone: 'Invalid phone',
    invalidNumber: 'Invalid number',
    invalidPassword: 'Invalid password',
    confirmPasswordNotMatch: 'Confirm password does not match',
    customerAlreadyExists: 'Customer already exists',
    fileSizeLimit: 'File size limit exceeded',
    fileNotAllowed: 'File extension not allowed',
    requiredCaptcha: 'Please, enter the captcha',
  },
  afterSubmit: {
    action: 'clearForm',
    message:
      '<h4>Thank you for getting in touch!&nbsp;</h4><p><br></p><p>We appreciate you contacting us. One of our colleagues will get back in touch with you soon!</p><p><br></p><p>Have a great day!</p>',
    redirectUrl: '',
  },
  integration: {
    shopify: {
      createAccount: false,
      ifExist: 'returnError',
      sendEmailInvite: false,
      acceptsMarketing: false,
      note:
        'Learn <a href="https://www.google.com/" target="_blank">how to connect</a> form elements to Shopify customer data',
      integrationElements: {},
    },
    mailChimp: {
      loading: '',
      enable: false,
      list: false,
      note:
        'Learn <a href="https://www.google.com/" target="_blank">how to connect</a> form elements to Mailchimp subscriber data',
      integrationElements: {},
    },
    klaviyo: {
      loading: '',
      enable: false,
      list: false,
      note:
        'Learn <a href="https://www.google.com/" target="_blank">how to connect</a> form elements to Klaviyo subscriber data',
      integrationElements: {},
    },
    zapier: { enable: false, webhookUrl: '' },
  },
  isStepByStepForm: false,
};
